import React, { Component } from 'react'
import { observer, Provider } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import Title from './components/Title'
import Extra from './components/Extra'
import CertificationItem from './components/CertificationItem'
import Store from './store'
import { HLJ_STATISTIC } from '@util'

const bodyStyle = { padding: '0 0 20px' }

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  componentDidMount() {
    this.store.init()

    HLJ_STATISTIC({
      element_tag: 'certification',
      event_type: 'element_view'
    })
  }

  render() {
    const { certificationList, isComplete } = this.store
    const isEmpty = isComplete && !certificationList.length
    const infoList = certificationList.map(item => (
      <CertificationItem key={item.id} item={item} />
    ))

    return (
      <Provider certificationStore={this.store}>
        <HeaderView
          contentStyle={bodyStyle}
          title={<Title />}
          extra={<Extra />}
        >
          {isEmpty ? (
            <img
              style={{ width: 140, margin: '40px auto 0', display: 'block' }}
              src="https://qnm.hunliji.com/o_1d71hhkuh15ep19p31pag16p7o479.png"
            />
          ) : (
            infoList
          )}
        </HeaderView>
      </Provider>
    )
  }
}
